export default function requireElement(root, selector) {
  const element = root.querySelector(selector)
  if (up.util.isMissing(element)) {
    console.debug(root)
    throw new Error(`Expected to find ${selector} in the element above`)
  } else {
    return element
  }
}
